<template>
  <v-row class="mt-3 mr-16 ">
    <v-col class="pt-0 d-flex justify-center">
      <v-card width="600" class="rounded-lg white pl-5 pr-5">
        <v-img
            width="700"
            src="/img/transactionFailed.png"
        ></v-img>
        <v-card-title style="font-weight: bold" class=" text-h4 error--text justify-center text-center pb-7">
          تراکنش ناموفق
        </v-card-title>
        <v-card-subtitle style="font-weight: bold" class=" justify-center text-center secondary--text">
          متاسفانه خرید شما تکمیل نشد
        </v-card-subtitle>
        <v-card-subtitle class="mt-1 justify-center text-center">
          در صورتی که از حساب شما مبلغی کسر شده طی 72 ساعت از طرف بانک عودت داده خواهد شد
          <br/>
          در صورتی که وجه به حساب شما عودت داده نشد از طریق بانک عامل پیگیری کنید
        </v-card-subtitle>
        <v-card-actions class="justify-center d-flex mb-5">
          <!-- <v-btn block outlined text class="rounded-lg error--text mr-5 ml-5" color="error" large> بازگشت </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-col>

  </v-row>
</template>
<script>



export default {
  name: "TransactionFailed",
  components: {
  },
  props: {
    id: {},
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },

}
</script>

<style scoped lang="scss"></style>

